import React from "react";
import "../style/NoMatch.css";

const NoMatch = () => {
  return <div className="no-match">404 Error: Page not found</div>;
};

export default NoMatch;
